// Atelier Williams Studio — shared art-direction tokens
export const C = {
  bg: "oklch(0.966 0.01 85)",
  bgCard: "oklch(0.99 0.006 85)",
  border: "oklch(0.89 0.01 80)",
  borderSoft: "oklch(0.87 0.01 80)",
  borderInput: "oklch(0.85 0.01 80)",
  ink: "oklch(0.22 0.012 60)",
  inkDeep: "oklch(0.2 0.014 62)",
  ink26: "oklch(0.26 0.012 60)",
  ink28: "oklch(0.28 0.012 60)",
  ink30: "oklch(0.3 0.012 60)",
  accent: "oklch(0.6 0.165 42)",
  green: "oklch(0.6 0.145 152)",
  text40: "oklch(0.4 0.014 62)",
  text42: "oklch(0.42 0.014 62)",
  text44: "oklch(0.44 0.014 62)",
  text46: "oklch(0.46 0.014 62)",
  text48: "oklch(0.48 0.014 62)",
  text52: "oklch(0.52 0.014 64)",
  text56: "oklch(0.56 0.014 64)",
  mut60: "oklch(0.6 0.014 66)",
  mut66: "oklch(0.66 0.012 70)",
  mut70: "oklch(0.7 0.012 74)",
  mut72: "oklch(0.72 0.012 74)",
  mut82: "oklch(0.82 0.012 78)",
  cream97: "oklch(0.97 0.008 85)",
  cream98: "oklch(0.98 0.006 85)",
  dark: "oklch(0.2 0.014 62)",
  darkLine: "oklch(0.34 0.012 62)",
  darkMut: "oklch(0.7 0.012 70)",
  err: "oklch(0.55 0.19 30)",
};

export const serif = "'Instrument Serif', Georgia, serif";
export const mono = "'Geist Mono', ui-monospace, monospace";
export const sans = "'Geist', -apple-system, BlinkMacSystemFont, sans-serif";

export const EASE = [0.16, 1, 0.3, 1];

export const scrollTo = (hash) => {
  const el = document.querySelector(hash);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -66, duration: 1.2 });
  else el.scrollIntoView({ behavior: "smooth" });
};
